/* -- COLORS -- */

export interface Color {
  name: string;
  hue: string;
  core: number;
  suggested: [number, number, number];
  muppet: string;
}

export const ColorTable: Color[] = [
  {
    name: 'Purple',
    hue: 'purple',
    core: 6,
    suggested: [2, 8, 9],
    muppet: 'Gorgon Heap',
  },
  {
    name: 'Blue',
    hue: 'blue',
    core: 5,
    suggested: [2, 7, 8],
    muppet: 'Grover',
  },
  {
    name: 'Mint',
    hue: 'mint',
    core: 3,
    suggested: [1, 6, 8],
    muppet: 'Rosita',
  },
  {
    name: 'Green',
    hue: 'green',
    core: 2,
    suggested: [1, 5, 8],
    muppet: 'Oscar',
  },
  {
    name: 'Yellow',
    hue: 'yellow',
    core: 2,
    suggested: [1, 4, 7],
    muppet: 'Bert',
  },
  {
    name: 'Orange',
    hue: 'orange',
    core: 4,
    suggested: [1, 6, 8],
    muppet: 'Ernie',
  },
  { name: 'Red', hue: 'red', core: 4, suggested: [1, 6, 8], muppet: 'Animal' },
  {
    name: 'Pink',
    hue: 'pink',
    core: 4,
    suggested: [1, 6, 8],
    muppet: 'Abby Cadabby',
  },
];

export const TOKEN_BLOCKS = [
  {
    name: 'Main background color',
    description:
      'The main light or dark background color of the page. Near white or dark gray.',
    variable: 'main-bkg-color',
    lightColor: 'var(--gray-1)',
    darkColor: 'var(--gray-9)',
  },
  {
    name: 'Modal background color',
    description: 'Background color used by modals. Pure white or dark gray.',
    variable: 'modal-bkg-color',
    lightColor: 'var(--white)',
    darkColor: 'var(--gray-8)',
  },
  {
    name: 'Surface color',
    description:
      'Slightly lighter or darker alternative to the main background color. Useful for a subtle contrast or for raised elements. All text should contrast properly with the Surface color.',
    variable: 'surface-bkg-color',
    lightColor: 'var(--white)',
    darkColor: 'var(--gray-8)',
  },
  {
    name: 'Border color',
    description:
      'Borders and other UI elements should achieve a 3:1 contrast ratio with the Surface Color.',
    variable: 'border-color',
    lightColor: 'var(--gray-5)',
    darkColor: 'var(--gray-5)',
  },
  {
    name: 'Border color (dim)',
    description:
      'Useful for disabled form fields, or for lesser, dimmer borders that are stylistic and not essential to the experience.',
    variable: 'border-color-dim',
    lightColor: 'var(--gray-3)',
    darkColor: 'var(--gray-7)',
  },
  {
    name: 'Border color (extra dim)',
    description: 'For extra subtle borders or dividers.',
    variable: 'border-color-extra-dim',
    lightColor: 'var(--gray-2)',
    darkColor: 'var(--gray-8)',
  },
  {
    name: 'Error color',
    description:
      'Use this color for error borders or icons to catch attention and signify danger.',
    variable: 'error-color',
    lightColor: 'var(--red-core)',
    darkColor: 'var(--red-core)',
  },
  {
    name: 'Text color',
    description:
      'Provides the highest grayscale color contrast possible. Used for headings and microtext.',
    variable: 'text-color',
    lightColor: 'var(--black)',
    darkColor: 'var(--white)',
  },
  {
    name: 'Text color (dim)',
    description:
      'Used for body text, this marks the dimmest grayscale contrast possible, while still hitting a 7:1 AAA contrast ratio with Surface Color.',
    variable: 'text-color-dim',
    lightColor: 'var(--gray-7)',
    darkColor: 'var(--gray-3)',
  },
  {
    name: 'Text color (inverse)',
    description: 'Inverse text color for use on dark backgrounds.',
    variable: 'text-color-inverse',
    lightColor: 'var(--white)',
    darkColor: 'var(--black)',
  },
  {
    name: 'Text color (inverse dim)',
    description: 'Dimmed inverse text color for use on dark backgrounds.',
    variable: 'text-color-inverse-dim',
    lightColor: 'var(--gray-3)',
    darkColor: 'var(--gray-7)',
  },
  {
    name: 'Link color',
    description: 'Used for default links.',
    variable: 'link-color',
    lightColor: 'var(--blue-6)',
    darkColor: 'var(--blue-3)',
  },
  {
    name: 'Link color (hover)',
    description: 'Used for links in hover states.',
    variable: 'link-color-hover',
    lightColor: 'var(--blue-4)',
    darkColor: 'var(--blue-5)',
  },
  {
    name: 'Link color (active)',
    description: 'Used for links in active states.',
    variable: 'link-color-active',
    lightColor: 'var(--blue-2)',
    darkColor: 'var(--blue-7)',
  },
  {
    name: 'Highlight color',
    description: 'The primary color indicator of the theme.',
    variable: 'highlight-color',
    lightColor: 'var(--blue-6)',
    darkColor: 'var(--blue-3)',
  },
];
